import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAudienceInsights } from '@app/components/hooks/useAudienceInsights';
import connect from '@app/utils/connect';
import { Typography, Spin } from '@app/ui';
import './styles/Audience.scss';
import AccountCards from './components/AccountCards';
import AudienceCharts from './components/AudienceCharts';
import AudienceLanguageChart from './components/AudienceLanguageChart';
const { Title } = Typography;

const Audience: React.FC = ({ client }: any) => {
    const { t } = useTranslation('ownedSocial');
    const { data, isLoading, isError } = useAudienceInsights({
        clientId: client.id,
    });

    const [selectedAccountId, setSelectedAccountId] = useState<number | null>(
        null,
    );

    const authenticatedAccounts =
        data?.order
            ?.map((id: string | number) => data.accountsById[id])
            .filter((acc: any) => acc?.isAuthenticated) ?? [];

    const selectedAccount =
        selectedAccountId != null
            ? authenticatedAccounts.find(acc => acc.id === selectedAccountId)
            : null;

    const shouldShowLanguageChart = useMemo(() => {
        return (
            selectedAccount?.insights?.language &&
            Object.keys(selectedAccount?.insights?.language).length > 0
        );
    }, [selectedAccount]);

    if (isLoading) {
        return (
            <div className="audience-loading">
                <Spin size="large" />
            </div>
        );
    }
    if (isError) return <div>{t('audience.errors.loadingData')}</div>;

    return (
        <div className="audience-container">
            <Title
                level={4}
                style={{
                    color: '#1f1f1f',
                    fontWeight: 400,
                    paddingLeft: 12,
                    fontSize: 32,
                    marginBottom: 0,
                }}
            >
                {t('audience.title')}
            </Title>
            <AccountCards
                authenticatedAccounts={authenticatedAccounts}
                selectedAccountId={selectedAccountId}
                setSelectedAccountId={setSelectedAccountId}
            />
            <AudienceCharts selectedAccount={selectedAccount} />
            {shouldShowLanguageChart && (
                <AudienceLanguageChart selectedAccount={selectedAccount} />
            )}
        </div>
    );
};

export default connect(['filters', 'client'])(Audience);
